import React, { useState, useEffect } from "react";
import Cards from "../../components/Cards/Cards";
import Search from "../../components/Search/Search";
import BackButton from "../../components/BackButton/BackButton";
import axios from "axios";
import "./styles.css";

function ModelPage({ onModelSelect, onBack, brand }) {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(
        `https://api.quieromac.com/retomas/inventory/celucambio/models?name=${brand}`
      )
      .then((response) => {
        const result = response.data.data;
        setData(result);
        setFilteredData(result);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, [brand]);

  const handleSearch = (searchTerm) => {
    const filtered = data.filter((item) =>
      item.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>
      <h1>Descubre cuánto ofrecemos por tu celular.</h1>
      <p className="description">Selecciona la referencia de tu celular</p>
      <div className="modelo">
        {/* <Search onSearch={handleSearch} /> */}
        <Cards
          list={filteredData}
          type="models"
          onModelSelect={onModelSelect}
        />
      </div>
      <BackButton onClick={onBack} />
    </div>
  );
}

export default ModelPage;
